export default __webpack_public_path__ + "static/media/Landing.088a88cd.jpg";